module.exports = __webpack_public_path__ + "static/media/data-spend.01a17549.png";